module.exports = __webpack_public_path__ + "static/media/t_sl.4ac85a47.pdf";